export const PrintablesBookRole = {
  Student: 'Student',
  Teacher: 'Teacher',
} as const

export type PrintablesBookRole = ValuesOf<typeof PrintablesBookRole>
